import { render, staticRenderFns } from "./transshipment.vue?vue&type=template&id=5a998003&scoped=true&"
import script from "./transshipment.vue?vue&type=script&lang=js&"
export * from "./transshipment.vue?vue&type=script&lang=js&"
import style0 from "./transshipment.vue?vue&type=style&index=0&id=5a998003&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a998003",
  null
  
)

export default component.exports